import { render, staticRenderFns } from "./TermsOfUseModal.vue?vue&type=template&id=4847b33d&scoped=true"
import script from "./TermsOfUseModal.vue?vue&type=script&lang=js"
export * from "./TermsOfUseModal.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUseModal.vue?vue&type=style&index=0&id=4847b33d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4847b33d",
  null
  
)

export default component.exports